// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e4e28293","453":"0d5e3373","455":"6e064533"}[chunkId] + ".chunk.js";
};